module.exports = __webpack_public_path__ + "img/chat-add.33358a35.svg";